import React, {useEffect, useMemo, useRef} from "react";
import {CustomLink} from "../../reusable_components/link/link";
import {DrawioReadonly} from "../../reusable_components/drawio_diagram";

export const TEXTS = {loadingText: "Retrieving architectures...", emptyTitle: 'No architectures', emptyMessage: 'You have not saved any architectures. Click on "Generate architecture" to get started.'}


export const CARD_DEFINITION = {
    header: item => (
            <CustomLink
                variant={'secondary'}
                href={`architectures/${item.id}`}
                fontSize="heading-m"
            >
                {item.title}
            </CustomLink>
    ),
    sections: [
        {
            id: "image",
            content: item => (
                <DrawioReadonly xml={item.diagramContent} />
            )
        },
        {
            id: "description",
            // header: (
            //     <div
            //         style={{
            //             display: "flex",
            //             flexDirection: "row",
            //             justifyContent: "space-between"
            //         }}
            //     >
            //         <span>Description</span>
            //     </div>
            // ),
            content: item => <div className={'ellipsis'}>{item.description}</div>
        }
    ]
}